/**
 * Difficulty, shared by the client and the server.
 *
 * Three levels, and they are part of the leaderboard key rather than a private
 * setting. That is the whole design decision here: a Snake record set on easy
 * and one set on hard are not the same achievement, and putting them on one
 * board would either punish the person who took the harder game or quietly
 * invite everybody to drop to easy. So each level keeps its own board, and
 * choosing an easier game costs you nothing except that you are ranked against
 * the people who chose it too.
 *
 * The names are the French ones the interface already uses, so the value stored
 * in the database and the word on the button are the same thing. Never rename
 * one: it is a primary key column.
 */
export const LEVELS = ['facile', 'moyen', 'difficile'];
/**
 * What you get if you never choose.
 *
 * Also what every score recorded before difficulty existed is treated as,
 * which is honest: those games were played at exactly these settings.
 */
export const DEFAULT_LEVEL = 'moyen';
export const LEVEL_LABEL = {
    facile: 'Facile',
    moyen: 'Moyen',
    difficile: 'Difficile',
};
/** How each level is described on the button, in one short line. */
export const LEVEL_BLURB = {
    facile: 'Plus lent, plus de marge.',
    moyen: 'Le jeu tel qu’il est pensé.',
    difficile: 'Plus rapide, moins de droit à l’erreur.',
};
const SET = new Set(LEVELS);
/**
 * Read a level off untrusted input.
 *
 * Anything unrecognised becomes the default rather than an error. A stray
 * query string should drop you on the normal board, not break the page.
 */
export function asLevel(value) {
    return typeof value === 'string' && SET.has(value) ? value : DEFAULT_LEVEL;
}
/**
 * Pick one of three values by level.
 *
 * Every game tunes itself through this, so a game's difficulty is one readable
 * line per knob instead of a switch statement per knob.
 */
export function byLevel(level, facile, moyen, difficile) {
    return level === 'facile' ? facile : level === 'difficile' ? difficile : moyen;
}
//# sourceMappingURL=levels.js.map